// extracted by mini-css-extract-plugin
export default {"root":"Logo__root___WUgun","large":"Logo__large___C0Lsh","light":"Logo__light___oAbT9"};